<!-- @ts-nocheck -->
<template>
  <ISTFormSearch
    v-if="isEnabled"
    v-bind="$attrs"
    v-model="modelValue"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :disable="disable || disabled"
    :readonly="readonly"
    :hint="hint || helpText"
    :dense="dense"
    @change="(value) => emit('change', { value })"
    @input="(value) => emit('input', value)"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </ISTFormSearch>
  <CuiSelect
    v-else
    v-model="modelValue"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled || disable"
    :readonly="readonly"
    :clearable="clearable"
    :invalid="invalid"
    :error="error"
    :required="required"
    :helpText="helpText || hint"
    optionLabel="label"
    optionValue="value"
    :filterable="true"
    v-bind="$attrs"
    @change="onChange"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </CuiSelect>
</template>

<script setup lang="ts">
import { CuiSelect } from "@ist/commonui-components";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpFormSearch");
defineOptions({ name: "dtpFormSearch", inheritAttrs: false });

type SelectOption = { label: string; value: any };

withDefaults(
  defineProps<{
    options?: SelectOption[];
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    readonly?: boolean;
    clearable?: boolean;
    invalid?: boolean;
    error?: string;
    required?: boolean;
    helpText?: string;
    hint?: string;
    disable?: boolean;
    dense?: boolean;
  }>(),
  {
    options: () => [],
    label: undefined,
    placeholder: undefined,
    disabled: false,
    readonly: false,
    clearable: false,
    invalid: false,
    error: undefined,
    required: false,
    helpText: undefined,
    hint: undefined,
    disable: false,
    dense: false
  }
);

const modelValue = defineModel<any>();

const emit = defineEmits<{
  (e: "input", value: any): void;
  (e: "change", payload: { value: any; option?: any }): void;
}>();

const onChange = (payload: { value: any; option?: any }) => {
  // Emit both change and input for backwards compatibility
  emit("change", payload);
  emit("input", payload.value);
};
</script>
